<div class="date-box" #box (clickOutside)="onOutDateRange($event)">
  <div class="flex align-items-center justify-content-between w-100" (click)="toggleDisplay()">
    <label for="" class="_fw-400">{{ dateName ? dateName : 'Select Date' }}</label>
    <img [src]="common_images?.calendar_time" alt="" />
  </div>
  <ng-container *ngIf="isDateRangeDisplay">
    <div class="dateRange" #panel [class.dateRange--fixed]="fixedPanel" [ngStyle]="fixedPanel ? panelStyle : null">
      <ul>
        <li
          *ngFor="let item of dateRange; let idx = index; let isLast = last"
          class="{{ !isLast && 'mb-1' }} _dateList-item"
          (click)="isSelected(item)">
          <div class="flex align-items-center gap-2">
            <p class="f-11">{{ item.name }}</p>
            <p class="ml-auto f-11" *ngIf="item?.from || item?.to">
              <ng-container *ngIf="isSingleDay(item); else rangeLabel">
                {{ item.from | date: item.format }}
              </ng-container>
              <ng-template #rangeLabel>
                {{ item.from ? (item.from | date: item.format) : '' }}
                -
                {{ item.to ? (item.to | date: item.format) : '' }}
              </ng-template>
            </p>
          </div>
        </li>
        <li class="mt-1 p-0 border-0">
          <p-calendar
            #customCal
            placeholder="Custom Date"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            name="created_at"
            showDelay="1000"
            [firstDayOfWeek]="1"
            (onClose)="customDateSelect()"
            [(ngModel)]="daterRange">
            <ng-template pTemplate="footer">
              <div class="d-flex justify-content-between align-items-center">
                <button class="_primary-btn he25" (click)="selectToday($event)">Today</button>
                <div class="d-flex align-items-center gap-2">
                  <button class="_primary-btn he25" (click)="clearCustomRange($event)">Clear</button>
                  <button class="_primary-btn he25" [disabled]="!canApply" (click)="applyCustomRange($event, customCal)">OK</button>
                </div>
              </div>
            </ng-template>
          </p-calendar>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
